module.exports = __webpack_public_path__ + "static/media/SWSCRC1-25.1a49a4f4.mp3";